import { File, Copy, Trash2, Tag, FolderOpen, PenSquare, ArrowUpDown, Key, Lock } from 'lucide-react';
import './FilesList.css';

function FilesList({ groupedFiles, groups, selectedFile, onFileSelect, onFileDelete, onFileClone, onGroupBulkEdit, isLoading, sortBy, sortDir, onSortChange, deviceSummary }) {
  if (isLoading) {
    return (
      <div className="files-list-loading">
        <div className="spinner"></div>
        <p>Загрузка...</p>
      </div>
    );
  }

  const allFiles = Object.values(groupedFiles || {}).flat();

  if (allFiles.length === 0) {
    return (
      <div className="files-list-empty">
        <p>Файлов нет</p>
        <small>Создайте первый файл подписки</small>
      </div>
    );
  }

  const sortOptions = [
    { key: 'name', label: 'А-Я' },
    { key: 'date', label: 'Дата' },
    { key: 'lines', label: 'Строки' },
  ];

  const renderFile = (file) => (
    <div
      key={file.name}
      className={`file-item ${selectedFile === file.name ? 'active' : ''}`}
    >
      <div className="file-info" onClick={() => onFileSelect(file.name)}>
        <div className="file-icon">
          <File size={15} />
        </div>
        <div className="file-details">
          <div className="file-name">
            {file.name.replace(/\.json$/, '')}
            {file.linesCount === 0 && <span className="empty-badge">пустой</span>}
            {/* Замок: массовое редактирование такой файл пропускает */}
            {file.locked && (
              <span className="lock-badge" title="Замок: массовое редактирование пропускает файл">
                <Lock size={9} />
              </span>
            )}
          </div>
          <div className="file-meta">
            <span>{file?.linesCount} строк</span>
            <span>{new Date(file.modified).toLocaleDateString('ru-RU')}</span>
            {deviceSummary?.[file.name] !== undefined && (() => {
              const { keyCount, maxDevices } = deviceSummary[file.name];
              const state = keyCount === 0 ? 'empty' : keyCount >= maxDevices ? 'full' : 'partial';
              return (
                <span className={`device-badge device-badge--${state}`}>
                  <Key size={9} /> {keyCount}/{maxDevices}
                </span>
              );
            })()}
          </div>
        </div>
      </div>
      {/* У дилера этих действий нет — он не создаёт и не удаляет файлы,
          поэтому обработчики не передаются и кнопки не рисуются вовсе. */}
      {(onFileClone || onFileDelete) && (
        <div className="file-actions">
          {onFileClone && (
            <button
              className="file-clone"
              onClick={(e) => { e.stopPropagation(); onFileClone(file.name); }}
              title="Дублировать"
            >
              <Copy size={13} />
            </button>
          )}
          {onFileDelete && (
            <button
              className="file-delete"
              onClick={(e) => { e.stopPropagation(); onFileDelete(file.name); }}
              title="Удалить"
            >
              <Trash2 size={13} />
            </button>
          )}
        </div>
      )}
    </div>
  );

  const entries = Object.entries(groupedFiles || {});
  const namedGroups = entries.filter(([id]) => id !== '__ungrouped');
  const ungrouped = groupedFiles['__ungrouped'] || [];

  return (
    <div className="files-list">
      <div className="sort-bar">
        <span className="sort-label">Сорт:</span>
        {sortOptions.map(opt => (
          <button
            key={opt.key}
            className={`sort-btn ${sortBy === opt.key ? 'sort-btn--active' : ''}`}
            onClick={() => onSortChange(opt.key, sortBy === opt.key && sortDir === 'asc' ? 'desc' : 'asc')}
          >
            {opt.label}
            {sortBy === opt.key && <span className="sort-arrow">{sortDir === 'asc' ? '↑' : '↓'}</span>}
          </button>
        ))}
      </div>

      {namedGroups.map(([groupId, groupFiles]) => {
        if (groupFiles.length === 0) return null;
        const groupName = groups[groupId]?.name || groupId;
        return (
          <div key={groupId} className="file-group">
            <div className="file-group-header">
              <span className="file-group-name">
                <Tag size={10} /> {groupName.toUpperCase()} ({groupFiles.length})
              </span>
              {onGroupBulkEdit && (
                <button
                  className="btn-group-bulk"
                  onClick={() => onGroupBulkEdit(groupId)}
                  title={`Редактировать группу "${groupName}"`}
                >
                  <PenSquare size={11} />
                </button>
              )}
            </div>
            {groupFiles.map(renderFile)}
          </div>
        );
      })}

      {ungrouped.length > 0 && (
        <div className="file-group">
          <div className="file-group-header">
            <span className="file-group-name">
              <FolderOpen size={10} /> БЕЗ ГРУППЫ ({ungrouped.length})
            </span>
          </div>
          {ungrouped.map(renderFile)}
        </div>
      )}
    </div>
  );
}

export default FilesList;
